import { combineReducers } from 'redux';
import { alertReducer } from './alertReducer';
import { authReducer } from './authReducer';
import { itemlookupReducer } from './itemlookupReducer';
import { locationsReducer } from './locations';
import { npcByBrandReducer } from './npcByBrandReducer';
import { npcByItemReducer } from './npcByItemReducer';
import { npcFbaFreightReducer } from './npcFbaFreightReducer';
import { npcInboundFreightReducer } from './npcInboundFreightReducer';
import { npcStorageReducer } from './npcStorageReducer';
import { userReducer } from './userReducer';
import { warehouseReducer } from './warehouseReducer';

export const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  alert: alertReducer,
  npcByBrand: npcByBrandReducer,
  npcByItem: npcByItemReducer,
  npcFbaFreigh: npcFbaFreightReducer,
  warehouse: warehouseReducer,
  npcStorage: npcStorageReducer,
  npcInboundFreight: npcInboundFreightReducer,
  itemlookup: itemlookupReducer,
  locations: locationsReducer
});

export type RootState = ReturnType<typeof rootReducer>;
